// Utilities
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

// Services
import {
  dailyReportService, // Importing the service to fetch user list
} from "../../../../../Api/Services/DailyReportService";

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IAdditionalManagersUsersListResponse } from "../../../../../Types/DailyReport";

/**
 * Async thunk to fetch user list.
 * Dispatches an API call to retrieve the user list data.
 */
export const fetchEmployeesListThunk = createServiceAsyncThunk<
  IAdditionalManagersUsersListResponse,
  {
    manager: boolean | number;
    page?: number;
    size?: number;
    name?: string;
    status?: number;
    email?: string;
  }
>(
  ACTION_NAMES.FETCH_EMPLOYEES_LIST, // Names of action
  (params) => dailyReportService.getUsersList(params), // API Call
  ERROR_MESSAGES.EMPLOYEES_LIST_FETCH_FAILURE // Error Message
);

/**
 * Slice to manage the state of user list details.
 * Includes actions to clear errors and handle async states.
 */
const employeesListSlice = createGenericSlice<
  IAdditionalManagersUsersListResponse, // RepsonseType
  {
    manager: boolean | number;
    page?: number;
    size?: number;
    name?: string;
    status?: number;
    email?: string;
  } // Payload Type
>(
  SLICE_NAMES.USER_LIST, // Name of the slice
  fetchEmployeesListThunk // Async Thunk
);

// Export actions for dispatching
export const { clearError: clearEmployeesListError } = employeesListSlice.actions;

// Export the reducer for integration in the Redux store

export default employeesListSlice.reducer;
